(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.headerResizeObserver.observe(this.header);
      this.querySelectorAll(".mr-header-search").forEach((search) => search.addEventListener("keydown", (event) => { if (event.key === "Escape") { const predictive = search.querySelector("predictive-search"); if (predictive) predictive.close(); } }));

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-muestra-producto"] && !Shopify.designMode) return;
  try {
    
  function initMRSample() {
    document.querySelectorAll('[data-mr-sample]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const variants = JSON.parse(root.querySelector('[data-mr-variants]').textContent);
      const options = [...root.querySelectorAll('[data-mr-option]')];
      const quantity = root.querySelector('[data-mr-quantity]');
      const status = root.querySelector('[data-mr-status]');
      const panel = root.querySelector('[data-mr-list]');
      const add = root.querySelector('[data-mr-add]');
      const key = 'mr_quote_list_v1';
      let items = [];
      try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(saved)) items = saved.filter(x => x && x.variant && Number.isInteger(x.quantity) && x.quantity > 0); } catch {}
      options.forEach(select => {
        if (!/talla|size/i.test(select.dataset.optionName)) return;
        const selected = select.value;
        const ranks = {XXS:0,XS:1,S:2,M:3,L:4,XL:5,XXL:6,'2XL':6,XXXL:7,'3XL':7,'4XL':8,'5XL':9};
        [...select.options].sort((a,b) => ranks[a.text] !== undefined && ranks[b.text] !== undefined ? ranks[a.text] - ranks[b.text] : a.text.localeCompare(b.text, 'es', {numeric:true})).forEach(x => select.add(x));
        select.value = selected;
      });
      const signFormat = root.querySelector('[data-mr-sign-format]');
      const signSize = root.querySelector('[data-mr-sign-size]');
      if (signFormat && signSize) {
        const combined = options[0];
        const split = value => value.split(' · ');
        signFormat.value = split(combined.value)[0];
        function sizes(preferred) {
          signSize.replaceChildren();
          [...combined.options].filter(o => split(o.value)[0] === signFormat.value).forEach(o => {
            const size = document.createElement('option');
            size.value = o.value;
            size.textContent = split(o.value)[1];
            signSize.append(size);
          });
          if ([...signSize.options].some(o => o.value === preferred)) signSize.value = preferred;
          combined.value = signSize.value;
        }
        sizes(combined.value);
        signFormat.addEventListener('change', () => { sizes(); });
        signSize.addEventListener('change', () => { combined.value = signSize.value; });
      }
      function current() { return options.length ? variants.find(v => options.every((s,i) => s.value === v.options[i])) : variants[0]; }
      function count() { return Math.max(1, Math.floor(Number(quantity.value) || 1)); }
      function lines(item) { return [item.title, item.variantTitle === 'Default Title' ? '' : root.dataset.selection + ': ' + item.variantTitle, root.dataset.quantity + ': ' + item.quantity, item.url].filter(Boolean).join('\n'); }
      function record(v) { const url = new URL(root.dataset.url); url.searchParams.delete('oseid'); url.searchParams.set('variant', String(v.id)); return {product:root.dataset.product, variant:String(v.id), title:root.dataset.title, variantTitle:window.MRSignLayers ? window.MRSignLayers.variantTitle(v) : v.title, quantity:count(), url:url.href}; }
      const steps = [...root.querySelectorAll('[data-mr-step]')];
      steps.forEach(button => button.addEventListener('click', () => {
        const value = Math.min(99999, Math.max(1, Math.floor(Number(quantity.value) || 1) + Number(button.dataset.mrStep)));
        quantity.value = String(value);
        quantity.dispatchEvent(new Event('input', {bubbles:true}));
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      const photo = root.querySelector('[data-mr-photo]');
      let photoMode = 'dark';
      let wasPhoto = false;
      function updatePhoto(v) {
        if (!photo || !v) return;
        const active = v.options.some(value => /fotoluminiscente/i.test(value));
        if (active && !wasPhoto) photoMode = 'dark';
        wasPhoto = active;
        photo.hidden = !active;
        const dark = active && photoMode === 'dark';
        const gallery = root.querySelector('.mr-sample__gallery');
        gallery.classList.toggle('mr-photo--dark', dark);
        gallery.classList.toggle('mr-photo--active', active);
        photo.querySelector('[data-mr-photo-caption]').hidden = !dark;
        photo.querySelectorAll('[data-mr-photo-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mrPhotoView === photoMode)));
        const image = root.querySelector('.mr-sample__image');
        const src = dark ? (signFormat.value === 'Solo pictograma' ? photo.dataset.darkSquare : photo.dataset.darkText) : v.featured_image.src;
        if (image.getAttribute('src') !== src) { image.removeAttribute('srcset'); image.src = src; }
        image.alt = root.dataset.title + ' — ' + signFormat.options[signFormat.selectedIndex].text + (dark ? ' — ' + photo.querySelector('[data-mr-photo-caption]').textContent : '');
      }
      if (photo) photo.querySelectorAll('[data-mr-photo-view]').forEach(button => button.addEventListener('click', () => { photoMode = button.dataset.mrPhotoView; update(); }));
      function update() {
        steps.forEach(button => { button.disabled = Number(button.dataset.mrStep) < 0 ? Number(quantity.value) <= 1 : Number(quantity.value) >= 99999; });
        const v = current(); add.disabled = !v || !quantity.checkValidity();
        if (signFormat && v) {
          const image = root.querySelector('.mr-sample__image');
          const src = v.featured_image && v.featured_image.src;
          if (image && src && image.dataset.variantImage !== src) {
            image.removeAttribute('srcset'); image.src = src;
            image.width = v.featured_image.width; image.height = v.featured_image.height;
            image.alt = root.dataset.title + ' — ' + signFormat.options[signFormat.selectedIndex].text;
            image.dataset.variantImage = src;
          }
          const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
        }
        updatePhoto(v);
        const link = root.querySelector('[data-mr-whatsapp]');
        link.setAttribute('aria-disabled', v ? 'false' : 'true');
        if (v) link.href = 'https://wa.me/51932043022?text=' + encodeURIComponent(root.dataset.request + '\n' + lines(record(v)));
      }
      function persist() { try { localStorage.setItem(key, JSON.stringify(items)); return true; } catch { status.textContent = root.dataset.storageError; return false; } }
      function render() {
        root.querySelector('[data-list-count]') && (root.querySelector('[data-list-count]').textContent = String(items.length));
        const list = root.querySelector('[data-mr-items]'); list.replaceChildren();
        if (!items.length) { const li = document.createElement('li'); li.textContent = root.dataset.empty; list.append(li); }
        items.forEach(item => { const li = document.createElement('li'); const text = document.createElement('span'); text.textContent = item.title + (item.variantTitle === 'Default Title' ? '' : ' — ' + item.variantTitle) + ' × ' + item.quantity; const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = root.dataset.remove; remove.addEventListener('click', () => { items = items.filter(x => x.variant !== item.variant); persist(); status.textContent = ""; render(); }); li.append(text, remove); list.append(li); });
        const send = root.querySelector('[data-mr-list-whatsapp]'); send.hidden = !items.length; send.href = 'https://wa.me/51932043022?text=' + encodeURIComponent(root.dataset.request + '\n\n' + items.map(lines).join('\n\n'));
      }
      root.querySelector('.mr-sample__list-toggle')?.addEventListener('click', () => { panel.hidden = !panel.hidden; if (!panel.hidden) panel.scrollIntoView({behavior:'smooth',block:'start'}); });
      add.addEventListener('click', () => { const v = current(); if (!v || !quantity.reportValidity()) return; const item = record(v); const old = items.find(x => x.variant === item.variant); if (old) old.quantity += item.quantity; else items.push(item); if (persist()) status.textContent = root.dataset.added; render(); });
      root.querySelector('[data-mr-whatsapp]').addEventListener('click', event => { if (!current() || !quantity.reportValidity()) event.preventDefault(); });
      root.addEventListener('change', update); quantity.addEventListener('input', update);
      update(); render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMRSample); else initMRSample();
  document.addEventListener('shopify:section:load', initMRSample);

  } catch(e) { console.error(e); }
})();
})();
